var map = {
	"./en": [
		6857,
		857
	],
	"./en.js": [
		6857,
		857
	],
	"./ja": [
		4807,
		807
	],
	"./ja.js": [
		4807,
		807
	],
	"./zh": [
		8184
	],
	"./zh.js": [
		8184
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3079;
module.exports = webpackAsyncContext;